import { render, staticRenderFns } from "./FaqHeader.vue?vue&type=template&id=1ec3897b&scoped=true"
import script from "./FaqHeader.vue?vue&type=script&lang=js"
export * from "./FaqHeader.vue?vue&type=script&lang=js"
import style0 from "./FaqHeader.vue?vue&type=style&index=0&id=1ec3897b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3897b",
  null
  
)

export default component.exports